import { Injectable } from '@angular/core';
import { Adapter } from '../../../../interfaces/Adapter';
import { JobLogResponse } from '../../../../interfaces/response/AdminPageResponses';

/**
 * An adapter converts job log HTTP response to domain object.
 */
@Injectable({
  providedIn: 'root'
})
export class JobLogAdapter implements Adapter<string> {

  /**
   * Converts job log HTTP response to {@link string}.
   * @param item job log HTTP response.
   */
  adapt(item: JobLogResponse): string {
    return item.logs.join('\n');
  }
}
